import { z } from 'zod'

import { successResponseSchema } from '@/api/resources/shared/success'
import { avatarMediaSchema } from '@/api/resources/shared/avatar'
import { seasonSchema } from '@/api/resources/shared/arcade'

const leaderboardGetInputSchema = z.object({
  season_id: z.string().optional(),
  from_rank: z.number().optional(),
  total_ranks: z.number().optional()
})

export const seasonStatisticsSchema = z.object({
  points_converted: z.number().nullable(),
  items_converted: z.number().nullable(),
  total_players: z.number().nullable(),
  rank_threshold_points: z.number().nullable(),
  player_points_available: z.number().optional().nullable(),
  player_points_converted: z.number().optional().nullable(),
  player_items_converted: z.number().optional().nullable()
})

export const playerRankSchema = z.object({
  id: z.number(),
  user_id: z.number(),
  season_id: z.number(),
  points: z.number(),
  rank: z.number(),
  current_player: z.boolean(),
  media: z.object({
    avatar_media: z.nullable(avatarMediaSchema),
    banner_media: z.string().nullable()
  }),
  account: z.string()
})

export const rankItemsSchema = z.array(playerRankSchema)

export const paginationSchema = z.object({
  prev_rank: z.number().nullable(),
  next_rank: z.number().nullable(),
  player_rank: z.number().nullable(),
  total_players: z.number()
})

export const leaderboardSchema = z.object({
  season: seasonSchema,
  season_stats: seasonStatisticsSchema.optional(),
  player_rank: z.number().nullable().optional(),
  total_players: z.number().nullable().optional(),
  leaderboard: rankItemsSchema.optional(),
  pagination: paginationSchema.optional()
})

export const leaderboardGetResponseSchema = successResponseSchema.extend({
  data: leaderboardSchema,
  timestamp: z.string().optional()
})

export type RankItem = z.infer<typeof playerRankSchema>
export type SeasonStatistics = z.infer<typeof seasonStatisticsSchema>
export type ArcadeLeaderboard = z.infer<typeof leaderboardSchema>
export type RankItems = z.infer<typeof rankItemsSchema>
export type RankItemsPagination = z.infer<typeof paginationSchema>

export type LeaderboardGetInput = z.infer<typeof leaderboardGetInputSchema>

export type LeaderboardGetResponse = z.infer<
  typeof leaderboardGetResponseSchema
>
